export default class Events{


    constructor(){
        this.listeners = {};
    }

    /**
     * Add an event listener
     * @param name
     * @param fn
     */
    addEventListener(name, fn){
        if(!this.listeners.hasOwnProperty(name)){
            this.listeners[name] = [];
        }

        this.listeners[name].push(fn);
    }

    /**
     * Remove a listener with the specific function
     * @param name
     * @param fn
     */
    removeEventListener(name, fn){
        if(this.listeners.hasOwnProperty(name)){
            let list = this.listeners[name];
            for(let i = 0; i < list.length;++i){
                if(list[i] === fn){
                    this.listeners[name].splice(i, 1);
                    break;
                }
            }
        }
    }

    /**
     * Remove all listeners to an event
     * @param name
     */
    removeEventListeners(name){
        if(this.listeners.hasOwnProperty(name)){
            this.listeners[name] = [];
        }
    }

    /**
     * Fire an event with the associated data
     * @param name
     * @param data
     */
    fireEvent(name, data = null){

        if(this.listeners.hasOwnProperty(name)){
            let list = this.listeners[name];
            for(let i = 0; i < list.length;++i){
                if(list[i] && typeof list[i] == "function"){
                    list[i](data);
                }
            }
        }

    }
}
